import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./style.module.css";

const Button = ({
  children,
  modifier = "style_light",
  href,
  clickHandler,
  className,
  disabled,
  type,
  ...rest
}) => {
  const classNames = cn(styles.button, className, {
    [styles[`button_${modifier}`]]: modifier,
    [styles.button_disabled]: disabled,
  });
  if (href) {
    // Внутренние переходы идём через роутер, чтобы к пути автоматически
    // прибавлялся basename (/foodgram) — иначе активная нав-кнопка уведёт
    // на корень домена вместо подпути.
    if (href.startsWith("/")) {
      return (
        <Link className={classNames} to={href} {...rest}>
          {children}
        </Link>
      );
    }
    return (
      <a className={classNames} href={href} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <button
      type={type || "button"}
      className={classNames}
      disabled={disabled}
      onClick={(_) => clickHandler && clickHandler()}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
